<template>
  <div>
    <Form ref="item" :model="item" :label-width="80">
      <Row>
        <Col span="8"
          ><FormItem label="工单号">
            {{ item.no }}
          </FormItem></Col
        >
        <Col span="8" v-for="(x, index) in forms" :key="index">
          <FormItem :label="x.title">
            <a @click="open(item[x.key])" v-if="x.open">{{ item[x.open] }}</a>
            <template v-if="x.type == 'lyyymmdd'">{{
              utils.time(item[x.key], "yymmdd")
            }}</template>
            <template v-if="x.type == 'Select'">
              {{ item[x.key] != null ? item[x.key].join(" / ") : "" }}
            </template>
            <template v-if="x.type == 'Input'">
              {{ item[x.key1] }}
            </template>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <h4 style="margin-bottom: 10px">验收单签字</h4>
    <Table border :columns="columns" :data="tableData" > </Table>
  </div>
</template>
<script>
import fields from "./forms/fields";
import rule from "./forms/rule";

export default {
  name: "docDetail",
  data() {
    return {
      openForm: false,
      item: {},
      searchItem: {
        id: "",
      },
      serverUrl: "",
      forms: [],
      title: "",
      columns: [
        {
          title: "职务",
          key: "job",
        },
        {
          title: "姓名",
          key: "name",
        },
        {
          title: "时间",
          key: "time",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.time, "yymmddhhmm"));
          },
        },
        {
          title: "签字意见",
          key: "opinion",
        },
      ],
      tableData: [],
      asdads: false,
    };
  },
  methods: {
    reach(v) {
      this.forms = fields["yanshou"];
      this.item = v;
    },
    getDetail() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dpm + "/accept/item",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data;
          console.log(data);
          if (data != null) {
            data.startTime = this.utils.time(data.startTime, "yymmdd");
            data.endTime = this.utils.time(data.endTime, "yymmdd");
            this.item = data;
            this.tableData = data.signList;
          }
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/yanshoudoc.vue